import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { IEvent, IEventHistoryCounts, IEventHistoryEntry } from '@app/api/interfaces/event.interface';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';

export const eventsKey = 'events';

export const eventsAdapter = createEntityAdapter<IEvent>({
  selectId: event => event.id,
  sortComparer: false,
});

export interface IEventsRequestState {
  projectId: string;
  areaId?: string;
  date?: string;
}

export interface IEventsState extends EntityState<IEvent> {
  loaded: boolean;
  loading: boolean;
  triggerId: string | null;
  request: IEventsRequestState | null;
  error: IApiBaseErrorResponse | null;
  history: Record<string, IEventHistoryEntry[]>;
  historyCounts: Record<string, IEventHistoryCounts>;
}

export const initialState: IEventsState = eventsAdapter.getInitialState({
  loaded: false,
  loading: false,
  triggerId: null,
  request: null,
  error: null,
  history: {},
  historyCounts: {},
});
